import { InjectionToken } from '@angular/core';
import { WwsArtikelstammConfiguration } from './types/artikelstamm-configuration';

export const SOFTLINE_PERMISSION_ARTIKELSTAMM = 'ARTSTAMM';

export const SOFTLINE_CONFIG_WWS_ARTIKELSTAMM =
  new InjectionToken<WwsArtikelstammConfiguration>(
    'SOFTLINE_CONFIG_WWS_ARTIKELSTAMM',
    {
      providedIn: 'root',
      factory: () => ({ readonly: false, hasProductDescriptionFeature: false }),
    }
  );
